import PropTypes from 'prop-types';
import { GRAPH_COPY, HIDDEN_OWNERS_CAUSE } from './graphConstants';

const MESSAGES = {
  [HIDDEN_OWNERS_CAUSE.SHARE_FILTER]: (percentageFilter) =>
    GRAPH_COPY.NO_OWNERS_AT_SHARE(percentageFilter ?? 0),
  [HIDDEN_OWNERS_CAUSE.FILTERS]: () => GRAPH_COPY.NO_OWNERS_FILTERED,
  [HIDDEN_OWNERS_CAUSE.NONE_ON_RECORD]: () => GRAPH_COPY.NO_OWNERS_ON_RECORD
};

/**
 * Why no shareholder is listed (PreparedGraph.noOwnersCause): 'No shareholders at or above 5%.',
 * 'No shareholders match the current filters.' or 'No shareholders on record.'. 'Change filter'
 * follows when a filter is the cause and onOpenFilters is given. Renders nothing without a cause.
 * No React Flow here: the levels table and the phone list render it in the main bundle.
 *
 * @param {Object} props
 * @param {string|null} [props.cause] - a HIDDEN_OWNERS_CAUSE
 * @param {number|string} [props.percentageFilter] - named for the share filter cause
 * @param {() => void} [props.onOpenFilters] - 'Change filter'
 * @param {string} [props.className]
 */
const NoOwnersMessage = ({ cause = null, percentageFilter, onOpenFilters, className }) => {
  const message = MESSAGES[cause];
  if (!message) return null;
  const canChangeFilter = !!onOpenFilters && cause !== HIDDEN_OWNERS_CAUSE.NONE_ON_RECORD;
  return (
    <output className={className}>
      <span>{message(percentageFilter)}</span>
      {canChangeFilter && (
        <>
          {' '}
          <button type="button" className="sg-link-button" onClick={onOpenFilters}>
            {GRAPH_COPY.CHANGE_FILTER}
          </button>
        </>
      )}
    </output>
  );
};

NoOwnersMessage.propTypes = {
  cause: PropTypes.oneOf(Object.values(HIDDEN_OWNERS_CAUSE)),
  percentageFilter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onOpenFilters: PropTypes.func,
  className: PropTypes.string
};

export default NoOwnersMessage;
